import React, { FC } from 'react'
import styles from './step.module.scss'
import { HearkenStatus } from 'types/hearkenStatus'
import { StepState } from './StepState'

interface StepProps {
  /** What step type this is supposed to be. Used for the selection of strings */
  stepType: HearkenStatus

  /** Should the step be marked as active */
  stepState: StepState

  /** The number to show */
  number: number

  /** The description to show below the header */
  description?: string

  /** The link to use for the description, likely an anchor */
  link?: string
}

export const Step: FC<StepProps> = ({
  children,
  number,
  stepState = 'upcoming',
  description,
  link
}) => {
  const DescriptionElement = link ? 'a' : 'div'

  return (
    <div className={`column ${styles.step} ${styles[stepState]}`}>
      <div className={styles.stepContents}>
        <div className={styles.bigNumber}>{number}</div>
        <div className={styles.content}>
          <div className={styles.header}>{children}</div>
          <DescriptionElement href={link} className={` ${styles.description}`}>
            {link && <i className='small down double angle icon' />}
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </DescriptionElement>
        </div>
      </div>
    </div>
  )
}
